import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { getAPI } from "services/CRUDServices"

export function usePayByWallet() {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const payByWallet = async (
 
    orderId: string,
    totalAmount: number
  ) => {
    setLoading(true)
    try {
      await getAPI(
        `/consignment-api/flow/customerInvoiceComplete/${orderId}?amount=${totalAmount}`
      )
      navigate("/order-management")
    } catch (err: any) {
      setLoading(false)
    }
  }
  return {
    payByWallet,
    loading,
  }
}
